<template>
    <generic-dropdown>
        <template slot="title">
            <slot />
        </template>
        <ul class="cms-content-our-range-filter__input-ul">
            <li
                v-for="(option, key) in options"
                :key="key"
                class="cms-content-our-range-filter__input-li"
            >
                <label
                    :for="`${id}${key}`"
                    class="cms-content-our-range-filter__input-label"
                    >{{ option }}</label
                >
                <input
                    class="cms-content-our-range-filter__input-checkbox"
                    :id="`${id}${key}`"
                    type="checkbox"
                    :name="option"
                    :value="option"
                    v-model="selectedOptions"
                    v-on:change="analyticsEvent"
                />
            </li>
        </ul>
    </generic-dropdown>
</template>

<script>
import GenericDropdown from "./GenericDropdown.vue";
import { customEvent } from "../../../modules/tracking/AnalyticsEvents";

export default {
    components: {
        GenericDropdown,
    },
    props: {
        optionKey: String,
        id: String,
        event: {
            type: Object,
            default: null,
        }
    },
    computed: {
        options() {
            return this.$store.state.availableOptions[this.optionKey] ?? [];
        },
        selectedOptions: {
            get() {
                return this.$store.state.selectedOptions[this.optionKey] ?? [];
            },
            set(value) {
                this.$store.dispatch("updateOptions", {
                    [this.optionKey]: value,
                });
            },
        },
    },
    methods: {
        analyticsEvent() {
            if (!this.event) {
                return;
            }

            if (this.selectedOptions.length <= this.previousOptions.length) {
                this.previousOptions = this.selectedOptions;
                return;
            }

            const difference = this.selectedOptions.filter(x => !this.previousOptions.includes(x));
            const { category, label } = this.event;
            customEvent(category, label, `${difference.toString()} Selected`)
            this.previousOptions = this.selectedOptions;
        }
    },
    data() {
        return {
            previousOptions: [],
        };
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/cms-content-slices/components/electric-test-drive/SelectDropdown.vue